export const EPG_ADD_ITEM_TO_MY_LIST_REQUEST = 'EPG_ADD_ITEM_TO_MY_LIST_REQUEST';
export const EPG_ADD_ITEM_TO_MY_LIST_SUCCESS = 'EPG_ADD_ITEM_TO_MY_LIST_SUCCESS';
export const EPG_ADD_ITEM_TO_MY_LIST_FAILURE = 'EPG_ADD_ITEM_TO_MY_LIST_FAILURE';
